<template>
  <v-container fill-height
               grid-list-xl>
    <v-layout justify-center
              wrap>
      <v-flex xs12 md10>
        <material-card :color="getTitleColorStore"
                       :title="$t('menu_digital_cerficates')"
                       :text="$t('digital_certificates.subtitle')">
          <ProgressBar :loading="loading" color="deep-purple accent-4" />
          <template>
            <v-container grid-list-md fluid>
              <v-layout row justify-center>

                <v-flex xs12>
                  <v-card>
                    <v-list two-line subheader>
                      <v-subheader >
                        <p v-if="items.length == 0 && items2.length == 0 && loading == false">{{ $t('digital_certificates.no_data') }}</p>

                      </v-subheader>

                      <v-list-tile v-for="item in items"
                                   :key="item.Naziv"
                                   avatar
                                   @click="downloadCertifikat(item)">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-list-tile-content v-on="on">
                              <v-list-tile-title>{{ item.ImeNaziv }}</v-list-tile-title>
                              <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                          </template>
                          <span>{{ $t('digital_certificates.subtitle') }}</span>
                        </v-tooltip>

                        <v-list-tile-action>
                          <v-list-tile-avatar>
                            <v-icon :class="[item.iconClass]">{{ item.icon }}</v-icon>
                          </v-list-tile-avatar>
                          <!--<v-btn icon ripple>
                            <v-icon color="grey lighten-1">info</v-icon>
                          </v-btn>-->
                        </v-list-tile-action>
                      </v-list-tile>



                      <!--<v-subheader inset>Pojedinačni seminari</v-subheader>-->
                      <v-list-tile v-for="item in items2"
                                   :key="item.Naziv"
                                   avatar
                                   @click="downloadCertifikat(item)">
                        <!--<v-list-tile-avatar>
                          <v-icon :class="[item.iconClass]">{{ item.icon }}</v-icon>
                        </v-list-tile-avatar>-->
                        <v-list-tile-content>
                          <v-list-tile-title>{{ item.ImeNaziv }}</v-list-tile-title>
                          <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                          <v-list-tile-avatar>
                            <v-icon :class="[item.iconClass]">{{ item.icon }}</v-icon>
                          </v-list-tile-avatar>
                          <!--<v-btn icon ripple>
                            <v-icon color="grey lighten-1">info</v-icon>
                          </v-btn>-->
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>

              </v-layout>
            </v-container>
          </template>

        </material-card>
      </v-flex>

    </v-layout>
  </v-container>

</template>

<script>
  import moment from 'moment';
  import { mapState, mapMutations, mapGetters } from 'vuex';

  export default {
    name: 'MyDigitalCertificate',

    computed: {
      ...mapGetters('app', { getTitleColorStore: 'getTitleColor' })
    },

    mounted() {
      this.ucitajPodatke();
    },

    data() {
      return {
        loading: false,
        podaci: [],
        items: [],
        items2: []
      }
    },

    methods: {
      async downloadCertifikat(item) {
        item.GetCertAsBase64 = true;
        this.loading = true;
        var result = await this.$fetchDataPromise('/api/DigitalCertificates/IzradiDigitalnuSvjedodzbu', item).catch(x => { this.loading = false; this.$displayErrorModal(x) });
        this.loading = false;
        
        this.$downloadByteArray(result.EncodedFile, result.Extension, result.Name);
      },

      async ucitajPodatke() {
        var self = this;
        this.loading = true;
        var result = await this.$fetchDataPromise('/api/DigitalCertificates/UcitajPodatke', null).catch(x => { this.loading = false; this.$displayErrorModal(x) });


        this.items = result.UpisaniSeminariOperatera
          .filter(x => x.IspunjavaUvjeteZaCertifikat == true)
          .map(x => {
            var obj = x;
            obj.icon = 'mdi-download';
            obj.ImeNaziv = `${x.Ime} (${x.Naziv})`;
            obj.subtitle = `${moment(x.DatumPocetka).format('DD.MM.YYYY')} - ${moment(x.DatumZavrsetka).format('DD.MM.YYYY')}`;
            obj.iconClass = 'blue white--text';
            return obj;
          });

        this.items2 = result.UpisaniSeminariPojedinca
          .filter(x => x.IspunjavaUvjeteZaCertifikat == true)
          .map(x => {
            var obj = x;
            obj.icon = 'mdi-download';
            obj.ImeNaziv = `${x.Ime} (${x.Naziv})`;
            obj.subtitle = `${moment(x.DatumPocetka).format('DD.MM.YYYY')} - ${moment(x.DatumZavrsetka).format('DD.MM.YYYY')}`;
            obj.iconClass = 'blue white--text';
            return obj;
          });

        this.loading = false;
      },
    }
  }
</script>



// WEBPACK FOOTER //
// VueSrc/Education/MyDigitalCertificate.vue